module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921082649_T.5703fc62.jpg";